import { render, staticRenderFns } from "./ZipWidgetPage.vue?vue&type=template&id=d5b982cc&"
import script from "./ZipWidgetPage.vue?vue&type=script&lang=js&"
export * from "./ZipWidgetPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports